export interface RegionOption {
  value: string;
  label: string;
}

export const REGION_OPTIONS: RegionOption[] = [
  { value: "na", label: "North America" },
  { value: "in", label: "India" },
  { value: "jp", label: "Japan" },
  { value: "eu", label: "Europe" },
  { value: "au", label: "Australia" },
  { value: "sg", label: "Singapore" },
  { value: "latam", label: "Latin America" },
  { value: "mena", label: "Middle East and North Africa" },
];

export const getCurrentRegion = (): string => {
  const hostname = window.location.hostname;
  // URL format: {stage}.{realm}.safer.whs.amazon.dev
  const parts = hostname.split(".");
  if (parts.length >= 2) {
    const realm = parts[1].toLowerCase();
    if (REGION_OPTIONS.some((opt) => opt.value === realm)) {
      return realm;
    }
  }
  return "na"; // default to NA for localhost or unknown
};

export const getCurrentRegionLabel = (): string => {
  const region = getCurrentRegion();
  const option = REGION_OPTIONS.find((opt) => opt.value === region);
  return option ? option.label : region.toUpperCase();
};

export const buildRegionUrl = (region: string): string => {
  let stage = "prod".toLowerCase();
  if (stage === "test") {
    stage = "beta";
  }
  return `https://${stage}.${region}.safer.whs.amazon.dev/`;
};
